import { useIfcMode } from '@editorHooks'

interface Upload {
  isAddActive: boolean
  toggleAdd: () => void
  closeAdd: () => void
}

/**
 * IFC upload panel state for the IFC Import page, backed by the global editor mode
 * (`'ifc-add'`). While active, the page drawer shows the IFC file upload form.
 */
const useIFCImportUpload = (): Upload => {
  const { ifcMode, setIfcMode } = useIfcMode()

  const isAddActive = ifcMode === 'add'

  const toggleAdd = () => setIfcMode(isAddActive ? null : 'add')
  const closeAdd = () => setIfcMode(null)

  return { isAddActive, toggleAdd, closeAdd }
}

export default useIFCImportUpload
